/* unplugin-vue-components disabled */import { render } from "./DeviceMac.vue?vue&type=template&id=1f272fb5&scoped=true"
import script from "./DeviceMac.vue?vue&type=script&lang=js"
export * from "./DeviceMac.vue?vue&type=script&lang=js"

import "./DeviceMac.vue?vue&type=style&index=0&id=1f272fb5&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/mianjuyry-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f272fb5"]])

export default __exports__